"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryCharacteristicStateSerializedSchema = void 0;
const zod_1 = require("zod");
const BoundaryAssertionStrength_1 = require("../BoundaryAssertionStrength");
const BoundaryCharacteristic_1 = require("../BoundaryCharacteristic");
const DesignModels_1 = require("../DesignModels");
const AbsoluteCharacteristicValue_1 = require("./AbsoluteCharacteristicValue");
const ISerializedCircuitState_1 = require("./ISerializedCircuitState");
exports.BoundaryCharacteristicStateSerializedSchema = zod_1.default.object({
    fromSource: zod_1.default.boolean().optional(),
    assertionStrength: zod_1.default.lazy(() => BoundaryAssertionStrength_1.BoundaryAssertionStrengthSchema),
    characteristic: zod_1.default.lazy(() => BoundaryCharacteristic_1.BoundaryCharacteristicSchema),
    circuitState: zod_1.default.lazy(() => ISerializedCircuitState_1.ISerializedCircuitStatePointerSchema),
    derivedFromBoundaries: zod_1.default.lazy(() => DesignModels_1.BoundaryGlobalIdRefSchema.array()),
    derivedFromSimulations: zod_1.default
        .lazy(() => AbsoluteCharacteristicValue_1.SimulationDefinitionSchema)
        .array()
        .optional(),
    derivedFromSpecifications: zod_1.default.string().array().optional(),
    value: zod_1.default.lazy(() => AbsoluteCharacteristicValue_1.AbsoluteCharacteristicValueSchema),
    isPartialResolution: zod_1.default.boolean().optional(),
});
//# sourceMappingURL=BoundaryCharacteristicStateSerialized.js.map